/* eslint-disable indent */
// These are the pages you can go to.
// They are all wrapped in the App component, which should contain the navbar etc
// See http://blog.mxstbr.com/2016/01/react-apps-with-pages for more information
// about the code splitting business
/* eslint-disable no-tabs */
import { getAsyncInjectors } from 'utils/asyncInjectors';

import App from 'containers/App';
import EmptyWebView from 'containers/EmptyWebView';
import RewardsPage from 'containers/RewardsPage';


const errorLoading = (err) => {
  console.error('Dynamic page loading failed', err); // eslint-disable-line no-console
};

const loadModule = (cb) => (componentModule) => {
  cb(null, componentModule.default);
};

const rootRedirect = (nextState, replace) => {
  const { location: { pathname } } = nextState;
  if (pathname !== '/') {
    return;
  }
  replace({
    pathname: '/home/1',
  });
};

export function createRoutes(store) {
  // Create reusable async injectors using getAsyncInjectors factory
  const { injectReducer, injectSagas } = getAsyncInjectors(store); // eslint-disable-line no-unused-vars

  const getComponentRedemption = (nextState, cb) => {
    const importModules = Promise.all([
      import('containers/RewardRedemptionPage/reducer'),
      import('containers/RewardRedemptionPage/sagas'),
      import('containers/RewardRedemptionPage'),
    ]);

    const renderRoute = loadModule(cb);

    importModules.then(([reducer, sagas, component]) => {
      injectReducer('rewardRedemptionPage', reducer.default);
      injectSagas(sagas.default);
      renderRoute(component);
    });

    importModules.catch(errorLoading);
  };

  const internalRoutes = {
    component: App,
    childRoutes: [{
      path: '/',
      onEnter: rootRedirect,
      component: RewardsPage,
      childRoutes: [{
        path: '/home/all',
        getComponent(nextState, cb) {
          const importModules = Promise.all([
            import('containers/RewardsPage/RewardsAllPage/reducer'),
            import('containers/RewardsPage/RewardsAllPage/sagas'),
            import('containers/RewardsPage/RewardsAllPage'),
          ]);

          const renderRoute = loadModule(cb);

          importModules.then(([reducer, sagas, component]) => {
            injectReducer('rewardsAllPage', reducer.default);
            injectSagas(sagas.default);
            renderRoute(component);
          });

          importModules.catch(errorLoading);
        },
      }, {
        path: '/home/:rewardCategoryId',
        getComponent(nextState, cb) {
          const importModules = Promise.all([
            import('containers/RewardsPage/RewardsPerCategoryPage/reducer'),
            import('containers/RewardsPage/RewardsPerCategoryPage/sagas'),
            import('containers/RewardsPage/RewardsPerCategoryPage'),
          ]);

          const renderRoute = loadModule(cb);

          importModules.then(([reducer, sagas, component]) => {
            injectReducer('rewardsPerCategoryPage', reducer.default);
            injectSagas(sagas.default);
            renderRoute(component);
          });

          importModules.catch(errorLoading);
        },
      }, {
        path: '/home/:rewardCategoryId/rewards/:id',
        getComponent(nextState, cb) {
          const importModules = Promise.all([
            import('containers/RewardPage/reducer'),
            import('containers/RewardPage/sagas'),
            import('containers/RewardPage'),
          ]);

          const renderRoute = loadModule(cb);

          importModules.then(([reducer, sagas, component]) => {
            injectReducer('rewardPage', reducer.default);
            injectSagas(sagas.default);
            renderRoute(component);
          });

          importModules.catch(errorLoading);
        },
      }],
    }, {
      path: '/login',
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import('containers/LoginPage'),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([component]) => {
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    }, {
      path: '/reset_password',
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import('containers/ResetPassword'),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([component]) => {
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    }, {
      path: '/reset_password_successful',
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import('containers/ResetPasswordSuccessful'),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([component]) => {
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    }, {
      path: '/rewards/:id/redeem-address',
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import('containers/RewardRedeemAddressPage'),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([component]) => {
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    }, {
      path: '/rewards/:id/redeem-details',
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import('containers/RewardRedeemDetailsPage/reducer'),
          import('containers/RewardRedeemDetailsPage/sagas'),
          import('containers/RewardRedeemDetailsPage'),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer('rewardRedeemDetailsPage', reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    }, {
      path: '/rewards/:id/redeem-confirmed',
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import('containers/RewardRedeemConfirmedPage'),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([component]) => {
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    }, {
      path: '/redemptions',
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import('containers/RedemptionsPage/reducer'),
          import('containers/RedemptionsPage/sagas'),
          import('containers/RedemptionsPage'),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer('redemptionsPage', reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    }, {
      path: '/rewards/:id/redemption',
      getComponent: getComponentRedemption,
    }, {
      path: '/redemptions/:id',
      getComponent: getComponentRedemption,
    }, {
      path: '/profiles/:id',
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import('containers/ProfilePage/reducer'),
          import('containers/ProfilePage/sagas'),
          import('containers/ProfilePage'),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer('profilePage', reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    }, {
      path: '/lotteries',
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import('containers/LotteriesPage/reducer'),
          import('containers/LotteriesPage/sagas'),
          import('containers/LotteriesPage'),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer('lotteriesPage', reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    }, {
      path: '/favorites',
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import('containers/FavoriteRewardsPage/reducer'),
          import('containers/FavoriteRewardsPage/sagas'),
          import('containers/FavoriteRewardsPage'),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer('favoriteRewardsPage', reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    }, {
      path: '/points',
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import('containers/PointsHistoryPage/reducer'),
          import('containers/PointsHistoryPage/sagas'),
          import('containers/PointsHistoryPage'),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([reducer, sagas, component]) => {
          injectReducer('pointsHistoryPage', reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    }, {
      path: '/rstos',
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          // import('containers/TosPage/reducer'),
          import('containers/TosPage/sagas'),
          import('containers/TosPage'),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([sagas, component]) => {
          // injectReducer('tosPage', reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    }, {
      path: '/rsprivacy',
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          // import('containers/PrivacyPage/reducer'),
          import('containers/PrivacyPage/sagas'),
          import('containers/PrivacyPage'),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([sagas, component]) => {
          // injectReducer('privacyPage', reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    },
    {
      path: '/rsfaq',
      getComponent(nextState, cb) {
        const importModules = Promise.all([
          import('containers/FaqPageDynamic/sagas'),
          import('containers/FaqPageDynamic'),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([sagas, component]) => {
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    }, /* ,

    {
      path: '/register-caregiver',
      name: 'registerCaregiver',
      getComponent(nextState, cb) {
        const importModules = Promise.all([

          import('containers/RegisterCaregiver/sagas'),
          import('containers/RegisterCaregiver'),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([sagas, component]) => {
          // injectReducer('registerCaregiver', reducer.default);
          injectSagas(sagas.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    }*/ {
      path: '/pages/:name',
      name: 'pages',
      getComponent(nextState, cb) {
        /* importModules.then(([reducer, menuReducer, videoReducer, sagas, component]) => { injectReducer('corpus', reducer.default); injectReducer('homepage', homePageReducer.default); injectSagas(sagas.default); renderRoute(component); });
*/

        const importModules = Promise.all([

          // import('containers/TosPage/reducer'),
          // import('containers/PrivacyPage/reducer'),
          import('containers/TosPage/sagas'),
          import('containers/PrivacyPage/sagas'),
          import('containers/FaqPageDynamic/sagas'),
          import('containers/Pages'),
        ]);

        const renderRoute = loadModule(cb);

        importModules.then(([/* privacyPageReducer, */sagasTos, sagasPrivacy, sagasFaq, component]) => {
          // injectReducer('tosPage', tosPageReducer.default);
          // injectReducer('privacyPage', privacyPageReducer.default);
          injectSagas(sagasTos.default);
          injectSagas(sagasPrivacy.default);
          injectSagas(sagasFaq.default);
          renderRoute(component);
        });

        importModules.catch(errorLoading);
      },
    }, {
      path: '/pagedeclined',
      name: 'pageDeclined',
      getComponent(location, cb) {
        import('containers/PageDeclined')
          .then(loadModule(cb))
          .catch(errorLoading);
      },
    }, {
      path: '*',
      name: 'notfound',
      getComponent(nextState, cb) {
        import('containers/NotFoundPage')
          .then(loadModule(cb))
          .catch(errorLoading);
      },
    }],
  };

  const externalRoutes = {
    component: EmptyWebView,
    childRoutes: [
      {
        path: '/faq',
        getComponent(nextState, cb) {
          const importModules = Promise.all([
            import('containers/FaqPageDynamic/sagas'),
            import('containers/FaqPageDynamic'),
          ]);

          const renderRoute = loadModule(cb);

          importModules.then(([sagas, component]) => {
            injectSagas(sagas.default);
            renderRoute(component);
          });

          importModules.catch(errorLoading);
        },
      },
      {
        path: '/privacy',
        getComponent(nextState, cb) {
          const importModules = Promise.all([
            import('containers/PrivacyPage/sagas'),
            import('containers/PrivacyPage'),
          ]);

          const renderRoute = loadModule(cb);

          importModules.then(([sagas, component]) => {
            injectSagas(sagas.default);
            renderRoute(component);
          });

          importModules.catch(errorLoading);
        },
      },
      {
        path: '/tos',
        getComponent(nextState, cb) {
          const importModules = Promise.all([
            import('containers/TosPage/sagas'),
            import('containers/TosPage'),
          ]);

          const renderRoute = loadModule(cb);

          importModules.then(([sagas, component]) => {
            injectSagas(sagas.default);
            renderRoute(component);
          });

          importModules.catch(errorLoading);
        },
      },
      {
        path: '/myrank',
        getComponent(nextState, cb) {
          const importModules = Promise.all([
            import('containers/LeaderboardPage/reducer'),
            import('containers/LeaderboardPage/sagas'),
            import('containers/LeaderboardPage'),
          ]);

          const renderRoute = loadModule(cb);

          importModules.then(([reducer, sagas, component]) => {
            injectReducer('leaderboardPage', reducer.default);
            injectSagas(sagas.default);
            renderRoute(component);
          });

          importModules.catch(errorLoading);
        },
      },
    ],

  };

  return [
    externalRoutes,
    internalRoutes,
  ];
}
